<div fxLayout="row" style="overflow-x: hidden;">
  <!-- <div class="urlDiv" fxLayout="row wrap">
    <a class="urls" href="">
      Home /
    </a>

    <a class="urls" href="contest/all-contest">
      &nbsp;contests /
    </a>
    <a class="urls" href="/contest/film">
      &nbsp;Film /
    </a>
    <a class="urls" href="/contest/{{contestId}}">
      &nbsp;{{titleHead}}
    </a>
  </div> -->
  <div class="hitmaker_image_new" fxLayout="column wrap" fxFlex="37">
    <img class="image1" [src]="backgroundImg" />
  </div>
  <br>
  <div fxLayout="row wrap">
    <p class="engageTitle"><strong> What you do</strong></p>
    <br />
    <p class="newPara" [innerHTML]="smallDesc">
    </p>
    <p class="engageTitle1"><strong style="line-height: 1;"> {{titleHead}}</strong></p>
    <br />
    <p class="newPara1">
      <span [innerHTML]="aboutDesc"> </span>
    </p>
    <br />


    <ng-container *ngIf="profilePic?.length > 0; else noData">
      <p class="newPara2">
        <owl-carousel-o [options]="carouselOptions" class="carousel" (translated)="onSlideChange($event)">
          <ng-container *ngFor="let item of profilePic; let i = index; trackBy: trackByFn" >
            <ng-template carouselSlide>
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span style="font-size: 18px; line-height: 22px; font-family: 'Lato-Bold';
                text-align: center; padding-bottom: 2%;">
                  {{ item.fullName }}
                </span>
                <img [src]="item.profilePicUrl" loading="lazy" [alt]="" (click)="onChange(i)"
                  [ngClass]="{ 'two-items': getNumberOfItems() === 2, 'four-items': getNumberOfItems() === 4 }" />
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </p>

      <div class="main-row" fxLayout="row wrap">
        <!-- Profile info start -->
        <div class="profile-col" *ngIf="isVideo !== null">
          <div class="info" *ngFor="let item of profilePic; let i = index">
            <div class="data" *ngIf="i <= 0">
              <img src="{{ profilePic[isVideo]?.profilePicUrl }}" />
              <p class="bio">
                {{ profilePic[isVideo]?.profileDesc }}
              </p>
              <button type="button" (click)="openDialog(item)" class="btn-read">
                Read More
              </button>
            </div>
          </div>
        </div>
        <!-- Profile info end -->

        <!-- Video details start -->
        <div *ngIf="isVideo !== null" fxLayout="row wrap" class="video-col">
          <ng-container *ngFor="let item of profilePic; let i = index">
            <div class="video-center" (click)="onVideoSelect(i)" *ngIf="i <= 0">
              <iframe [src]="profilePic[isVideo]?.profileVideoUrl" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
              <br>
              <p class="about-profile" style="font-family: 'Lato';">
                <b>Click the video above to review
                  {{ profilePic[isVideo]?.fullName }}'s audition video</b>
              </p>

              <div class="starDiv">
                <div>
                  <app-star-rate
                    [rating]="rating"
                    [starCount]="starCount"
                    [color]="starColor"
                    (ratingUpdated)="onRatingChanged($event)">
                  </app-star-rate>
  
                  <p class="rate">
                    You voted <b>{{rating}} STARS.</b>
                    Thank you!
                  </p>
                </div>
            
                <div *ngIf="type === 'FANS CAST IT' || type === 'FAN CAST IT'" style="margin-top: 1%;">
                  <button 
                    [ngClass]="{'castingButton': type === 'FANS CAST IT' || type === 'FAN CAST IT'}" 
                    (click)="getStageDetails('casting', $event)">
                    Casting Updates
                  </button>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
        <!-- Video details end -->
      </div>
    </ng-container>

    <!-- No Data Message -->
    <ng-template #noData>
      <div style="display: flex; justify-content: center; align-items: center; min-height: 200px; font-size: 24px; font-family: 'Lato-Bold'; text-align: center;">
        No contestants added
      </div>
    </ng-template>

    <div class="recommend">
      <h2>OUR RECOMMENDATIONS</h2>
      <div class="recommend-data" style="margin-bottom: 10px !important;">
        <div class="img-recommend" *ngFor="let img of data">
          <img 
            src="{{ img.recommendImageUrl }}" 
            (click)="recommedImg(img.id)" 
            class="recommend-img" 
          />

          <p class="className" style="margin-top: 5px;">{{ img.name }}</p>
        </div>
      </div>
    </div>
    
  </div>
</div>

<!-- popup for read more -->
<ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
  <div fxLayout="column" class="main-container">
    <div class="close-icon-container">
      <button class="close-icon" (click)="dialogRef.close()">
        <i class="bi bi-x-lg" style="font-size: 28px;"></i>
      </button>
    </div>
    <div class="custom-dialog-container">
      <div class="image-container">
        <img class="image" src="{{  profilePic[isVideo]?.profilePicUrl }}" alt="image">
      </div>
      <div fxFlex="100%" class="flex-column">
        <p class="cname">{{ profilePic[isVideo]?.fullName }}</p>
        <p class="bio-desc" [ngClass]="{ 'read-less': showShortDescription }">
          {{ profilePic[isVideo]?.profileDesc }}
        </p>
      </div>
    </div>
  </div>
</ng-template>
